export default function (state = [], action) {
  switch (action.type) {
    case "GET_STAT":
      return action.payload;
      break;
    default:
      return state;
  }
}
